<template>
    <div class="md-layout-item md-medium-size-75 md-xsmall-size-100 md-size-50 p-2">
        <stats-card data-background-color="blue">
            <template slot="header">
                <md-icon>school</md-icon>
            </template>

            <template slot="content">
                <div class="loader" v-if="loading"></div>
                <div v-else>
                    <h5 class="category">{{ $t('lectors') }}</h5>
                    <h4 class="title">{{count}}</h4>
                </div>
            </template>

            <template slot="footer">
                <div class="stats">
                    <md-icon class="text-success">details</md-icon>
                    <a href="#" @click.stop="goToEvents">{{ $t('seeMore')}}</a>
                </div>
            </template>
        </stats-card>
    </div>
</template>

<script>
    import StatsCard from "@/components/cards/StatsCard";

    export default {

        props: {
            getValid: {
                type: Boolean,
                default: true
            },
            yearFilterValue: {
                type: [Number, String],
                default: 999
            }
        },
        components: {
            'stats-card': StatsCard
        },
        data() {
            return {
                loaded: false,
                loading: false,
                count: ''
            }
        },
        methods: {
            loadParticipantsCount() {
                this.loading = true;
                this.$http.get(this.getApiUrl(), { params: { yearSelectorValue: this.yearFilterValue } }).then(result => {
                    this.count = Number(result.data.count)
                }).catch(error => {

                }).then(() => {
                    this.loading = false;
                    this.loaded = true;
                });
            },
            goToEvents() {
                this.$router.push({ path: '/registers/lectors' });
            },
            getApiUrl() {
                if (this.getValid) {
                    return '/api/lectors/validCount';
                }

                return '/api/lectors/allCount';
            },
        },
        mounted() {
            this.loadParticipantsCount();

            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
        },
        computed: {
            isBgCulture() {
                return this.$store.getters.currentCulture === Culture.BG;
            }
        },
        watch: {
            yearFilterValue: function (val) {
                if (this.loaded) {
                    this.loadParticipantsCount();
                }
            }
        }
    }
</script>
